// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b8be3139","337":"d5895175","488":"e028a2b0","553":"52f81182"}[chunkId] + ".chunk.js";
};